import { render, staticRenderFns } from "./FontAwesomeIcons.vue?vue&type=template&id=a9153966"
import script from "./FontAwesomeIcons.vue?vue&type=script&lang=js"
export * from "./FontAwesomeIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports